module.exports = __webpack_public_path__ + "img/car_racing.e9d7cc2d.jpg";